import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";
import { appConfig } from "src/config";

export const Seo = (props) => {
  const { title } = props;

  const fullTitle = title ? `${title} | ${appConfig.title}` : appConfig.title;

  return (
    <Helmet>
      <title>{fullTitle}</title>
    </Helmet>
  );
};

Seo.propTypes = {
  title: PropTypes.string,
};
